import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "sonner";

import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { MobileReserveBar } from "@/components/MobileReserveBar";
import { PresentationMode } from "@/components/PresentationMode";
import { Tracker } from "@/components/Tracker";

import Home from "@/pages/Home";
import MenuPage from "@/pages/MenuPage";
import PrivateDiningPage from "@/pages/PrivateDiningPage";
import OurStoryPage from "@/pages/OurStoryPage";
import ReservationsPage from "@/pages/ReservationsPage";
import VisionPage from "@/pages/VisionPage";
import MobilePage from "@/pages/MobilePage";
import DressCodePage from "@/pages/DressCodePage";
import SiteAuditPage from "@/pages/SiteAuditPage";
import AdminVisitors from "@/pages/AdminVisitors";

// Bridge: expose lenis globally + handle route/hash scrolling through Lenis
const ScrollManager = () => {
  const lenis = useLenis();
  const { pathname, hash, search } = useLocation();

  useEffect(() => {
    if (lenis) window.lenis = lenis;
  }, [lenis]);

  useEffect(() => {
    const toTop = () => {
      if (lenis) lenis.scrollTo(0, { immediate: true });
      else window.scrollTo(0, 0);
    };
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        if (lenis) setTimeout(() => lenis.scrollTo(el, { offset: -80 }), 350);
        else setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 350);
        return;
      }
    }
    toTop();
  }, [pathname, hash, search, lenis]);

  return null;
};

// Public site chrome (nav/footer/CTAs) — hidden on the private /admin route
const SiteChrome = ({ position }) => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  if (position === "top") return <Nav />;
  return (
    <>
      <Footer />
      <MobileReserveBar />
      <PresentationMode />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true, wheelMultiplier: 1 }}>
        <BrowserRouter>
          <ScrollManager />
          <Tracker />
          <SiteChrome position="top" />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<MenuPage />} />
            <Route path="/private-dining" element={<PrivateDiningPage />} />
            <Route path="/our-story" element={<OurStoryPage />} />
            <Route path="/reservations" element={<ReservationsPage />} />
            <Route path="/vision" element={<VisionPage />} />
            <Route path="/mobile" element={<MobilePage />} />
            <Route path="/dress-code" element={<DressCodePage />} />
            <Route path="/site-audit" element={<SiteAuditPage />} />
            <Route path="/admin" element={<AdminVisitors />} />
          </Routes>
          <SiteChrome position="bottom" />
          <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "#161412", border: "1px solid rgba(193, 39, 45,0.3)", color: "#fff", borderRadius: 0 } }} />
        </BrowserRouter>
      </ReactLenis>
    </div>
  );
}

export default App;
